import { formatDate } from 'utils/masks'

const customCreatedAtRender = (value) => {
  return formatDate(value, { hideHour: true })
}

export const columnsOrganization = [
  {
    name: 'name',
    label: 'Nome',
  },
  {
    name: 'created_at',
    label: 'Criado em',
    options: {
      customBodyRender: customCreatedAtRender,
    },
  },
]
